module.exports = __webpack_public_path__ + "static/media/S3N5-4.09faa2a5.svg";